import dayjs from 'dayjs';

const isValidDate = (date) => {
  if (date == null) return true;
  return dayjs(date, 'YYYY-MM-DD', true).isValid();
};

const ALLOWED_UNITS = new Set(['d', 'w', 'm']);
const DAY_FLAGS = ['is_day_of','is_day_before','is_day_after','is_everything_after'];
const FLAG_KEYS = [...DAY_FLAGS, 'is_after'];
const ALLOWED_KEYS = new Set(['units','range','value', ...FLAG_KEYS]);

const isObj = (v) => v !== null && typeof v === 'object';

export const isValidTimeframe = (tf) => {
  if (tf == null) return true;
  if (!isObj(tf)) return false;

  /* eslint-disable no-restricted-syntax */
  for (const k in tf) if (!ALLOWED_KEYS.has(k)) return false;
  for (const k of FLAG_KEYS) if (k in tf && typeof tf[k] !== 'boolean') return false;
  /* eslint-enable no-restricted-syntax */

  const hasRange = 'range' in tf;
  const hasValue = 'value' in tf;
  const hasAnyDayFlag = DAY_FLAGS.some((k) => tf[k] === true);

  if ((hasRange && hasValue) || (hasAnyDayFlag && (hasRange || hasValue))) return false;

  if (hasAnyDayFlag) {
    const flagsCount = DAY_FLAGS.reduce((n, k) => n + (tf[k] ? 1 : 0), 0);
    if (flagsCount !== 1) return false;
    if ('units' in tf || tf.is_after) return false;
    return true;
  }

  if (hasRange || hasValue) {
    if (!tf.units || !ALLOWED_UNITS.has(tf.units)) return false;
  }
  if (hasRange) {
    const { range } = tf;
    if (!isObj(range)) return false;
    const { start, end } = range;
    if (!Number.isInteger(start) || start < 1) return false;
    if (end != null) {
      if (!Number.isInteger(end) || end < 1 || end <= start) return false;
    }
  }

  if (hasValue) {
    if (!Number.isInteger(tf.value) || tf.value < 1) return false;
  }

  if (!hasRange && !hasValue) return false;
  return true;
};

export const validateChecklistField = (field, value) => {
  switch (field) {
    // String
    case 'title':
    case 'details':
    case 'assignmentNote':
      return typeof value === 'string';
    // Boolean
    case 'completed':
      return typeof value === 'boolean';
    // Date
    case 'dueDate':
      return isValidDate(value);
    case 'timeframe':
      return isValidTimeframe(value);
    default:
      return true;
  }
};
